/**
 * HUB-H — Helpers onglet Équipe (audit / supervision Carlos-only).
 */

export const EQUIPE_SECTIONS = {
  OVERVIEW: 'overview',
  AUDIT: 'audit',
  ALERTES: 'alertes',
  SECURITE: 'securite',
};

export const SEVERITY_META = {
  info: { label: 'Info', badge: 'rm-badge rm-badge--muted' },
  warning: { label: 'Attention', badge: 'rm-badge rm-badge--muted' },
  critical: { label: 'Critique', badge: 'rm-badge rm-badge--danger' },
};

export const FRAUD_SEVERITY_META = {
  warning: { label: 'Attention', badge: 'rm-badge rm-badge--muted' },
  critical: { label: 'Critique', badge: 'rm-badge rm-badge--danger' },
};

export const SECURITY_EVENT_LABELS = {
  ip_banned: 'IP bannie',
  ip_unbanned: 'IP débloquée',
  rate_limit: 'Limite de débit',
  blocked_request: 'Requête bloquée',
  password_changed: 'Mot de passe modifié',
  clipboard_block: 'Copie bloquée',
  email_settings_change: 'Config email modifiée',
};

export function formatEquipeDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function isInDateRange(isoDate, dateDebut, dateFin) {
  if (!dateDebut && !dateFin) return true;
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return !dateDebut && !dateFin;
  const day = d.toISOString().slice(0, 10);
  if (dateDebut && day < dateDebut) return false;
  if (dateFin && day > dateFin) return false;
  return true;
}

export function matchesAuditSearch(log, search) {
  if (!search?.trim()) return true;
  const q = search.trim().toLowerCase();
  const haystack = [
    log.action,
    log.entity_type,
    log.entity_id,
    log.username,
    log.role,
    log.boutique,
    log.severity,
    JSON.stringify(log.details || {}),
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return haystack.includes(q);
}

export function matchesSecuritySearch(event, search) {
  if (!search?.trim()) return true;
  const q = search.trim().toLowerCase();
  const haystack = [
    event.type,
    event.ip,
    event.details,
    event.username,
    event.actor,
    event.path,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return haystack.includes(q);
}

export function securityEventLabel(type) {
  return SECURITY_EVENT_LABELS[type] || type || 'Événement sécurité';
}

export function formatAuditDetails(details) {
  if (!details || typeof details !== 'object') return '—';
  const entries = Object.entries(details).slice(0, 4);
  if (!entries.length) return '—';
  return entries.map(([k, v]) => `${k}: ${v}`).join(' · ');
}

export function computeTeamActivity(logs = []) {
  const counts = {};
  logs.forEach((log) => {
    const user = log.username || 'system';
    counts[user] = (counts[user] || 0) + 1;
  });
  return Object.entries(counts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 8)
    .map(([username, count]) => ({ username, count }));
}

export function magasinFromLog(log) {
  const details = log.details || {};
  return details.magasin_id || details.magasin || log.boutique || null;
}
